import { Role } from "./types";

export const getAllRoles = (): Role[] => Object.values(Role);

export const getRoleLabel = (role: Role): string => {
  switch (role) {
    case Role.DEVELOPER:
      return "Developer";
    case Role.PRODUCTOWNER:
      return "Product Owner";
    case Role.OTHER:
      return "Other";
    default: {
      const unhandledRole: never = role;
      throw new Error(`Unknown role: ${String(unhandledRole)}`);
    }
  }
};
